import { Box, useTheme } from "@mui/material";
import { DonutChart } from "~/components/charts/donut-chart";
import { getColor } from "~/lib/colors";
import { Metrics } from "~/lib/arrow";
import { useMetrics } from "~/hooks";
import DashboardSkeleton from "~/pages/organization/dashboard/DashboardSkeleton";

export type AssetsTodayProps = {
  organizationMrn: string;
};

const displayRatings = [
  "critical",
  "high",
  "medium",
  "low",
  "none",
  "pass",
  "error",
] as const;

export function AssetsToday({ organizationMrn }: AssetsTodayProps) {
  const theme = useTheme();

  const { assetRiskRatings, isLoading } = useMetrics({
    entityMrn: organizationMrn,
    metricMrns: [Metrics.AssetsRiskRatingDistribution],
  });

  if (isLoading) {
    return <DashboardSkeleton />;
  }

  const donutData = displayRatings
    .map((rating) => {
      const entry = assetRiskRatings?.context?.find((c) => c.rating === rating);
      return {
        label: rating,
        value: entry?.value || 0,
        color: getColor(theme, rating),
      };
    })
    .filter((d) => d.value > 0);

  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        pt: 2,
        "> .MuiGrid-root": { padding: 0, maxWidth: "350px", mx: "auto" },
      }}
    >
      <DonutChart data={donutData} dataType="assets" />
    </Box>
  );
}
